import { api_configuration } from "../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import api_gui = api_configuration.libraries.gui_definition_lib.types.gui_model.alan_api;
import { gui_model } from "./state/ClientState";

export function getGuiNode(node_type: api_app.Cnode__application): api_gui.Cgui_node | undefined {
	const location = node_type.input.location();
	switch (location.variant.name) {
		case "root": {
			const $ = location.variant.definition;
			switch ($.variant.name) {
				case "operation": {
					const operation = $.variant.definition;
					switch (operation.variant.name) {
						case "command": {
							const command = operation.variant.definition;
							switch (command.properties.type.state.name) {
								case "global": {
									const global = command.properties.type.state.node;
									return getGuiCommand(global)?.properties.parameters;
								}
								case "component":
									return undefined;
								default:
									unexpectedState(command.properties.type.state);
							}
							break;
						}
						case "action": {
							const action = operation.variant.definition;
							return getGuiAction(action)?.properties.parameters;
						}
						default:
							unexpectedState(operation.variant);
					}
					break;
				}
				case "dataset":
					return gui_model.root.properties.root;
				default:
					unexpectedState($.variant);
			}
			break;
		}
		case "group": {
			const $ = location.variant.definition;
			return getGuiGroup($)?.properties.gui_node;
		}
		case "state": {
			const $ = location.variant.definition;
			return getGuiStategroup($.parent)?.properties.states.get($.key)!.properties.gui_node;
		}
		case "collection": {
			const $ = location.variant.definition;
			return getGuiCollection($)?.properties.node;
		}
		default:
			unexpectedState(location.variant);
	}
}
export function getGuiAttribute(attribute_type: api_app.Cattributes): api_gui.Cattributes | undefined {
	return getGuiNode(attribute_type.parent)?.properties.attributes.get(attribute_type.key);
}
export function getGuiCommand(command_type: api_app.Cglobal): api_gui.Cglobal | undefined {
	return getGuiAttribute(command_type.parent.parent)?.properties.type.cast("command").properties.type.cast("global");
}
export function getGuiAction(action_type: api_app.Caction): api_gui.Caction__type | undefined {
	return getGuiAttribute(action_type.parent)?.properties.type.cast("action");
}
export function getGuiText(
	text_type: api_app.Ctext__type__property
): api_gui.Ctext__type__property__type__attributes | undefined {
	return getGuiAttribute(text_type.parent.parent)?.properties.type.cast("property").properties.type.cast("text");
}
export function getNavigableGuiText(text_type: api_app.Ctext__type__property): api_gui.Cyes__navigable | undefined {
	const gui_text = getGuiText(text_type);
	if (gui_text !== undefined) {
		switch (gui_text.properties.navigable.state.name) {
			case "yes": {
				return gui_text.properties.navigable.state.node;
			}
			case "no": {
				return undefined;
			}
		}
	}
	return undefined;
}

export function getGuiRule(rule: api_app.Crules): api_gui.Crules | undefined {
	const definer = rule.parent.input.definer();
	switch (definer.variant.name) {
		case "state": {
			const app_state = definer.variant.definition;
			return getGuiStategroup(app_state.parent)
				?.properties.states.get(app_state.key_value)
				?.properties.rules.properties.rules.get(rule.key_value);
		}
		case "text": {
			const app_text = definer.variant.definition;
			const gui_reference = getNavigableGuiText(app_text.parent);
			if (gui_reference) {
				return gui_reference.properties.rules.properties.rules.get(rule.key_value);
			}
			break;
		}
	}
	return undefined;
}
export function getGuiNumber(
	number_type: api_app.Cnumber__type__property
): api_gui.Cnumber__type__property__type__attributes | undefined {
	return getGuiAttribute(number_type.parent.parent)?.properties.type.cast("property").properties.type.cast("number");
}
export function getGuiFile(file_type: api_app.Cfile): api_gui.Cfile__type__property | undefined {
	return getGuiAttribute(file_type.parent.parent)?.properties.type.cast("property").properties.type.cast("file");
}
export function getGuiGroup(group_type: api_app.Cgroup__type__property): api_gui.Cgroup__type__property | undefined {
	return getGuiAttribute(group_type.parent.parent)?.properties.type.cast("property").properties.type.cast("group");
}
export function getGuiStategroup(
	stategroup_type: api_app.Cstate_group
): api_gui.Cstate_group__type__property__type__attributes | undefined {
	return getGuiAttribute(stategroup_type.parent.parent)
		?.properties.type.cast("property")
		.properties.type.cast("state group");
}
export function getGuiCollection(
	collection_type: api_app.Ccollection__type__property
): api_gui.Ccollection__type__property | undefined {
	return getGuiAttribute(collection_type.parent.parent)
		?.properties.type.cast("property")
		.properties.type.cast("collection");
}
